import reducer from './reducers';
import * as uploadActions from './actions';

export { uploadActions };
export default reducer;
